import { api } from './base';

export const billingApi = {
  getUsageSummary: async (period: string) => {
    const response = await api.get('/v2/usage/summary', { params: { period } });
    return response.data.data;
  },

  getUsageRaw: async (params: {
    startDate: string;
    endDate: string;
    userId?: string;
    format?: 'json' | 'csv';
    cursor?: string;
  }) => {
    const response = await api.get('/v2/usage/raw', { params });
    return response.data;
  },

  exportUsageCsv: async (startDate: string, endDate: string): Promise<Blob> => {
    const response = await api.get('/v2/usage/raw', {
      params: { startDate, endDate, format: 'csv' },
      responseType: 'blob',
    });
    return response.data;
  },

  getCurrentSubscription: async () => {
    const response = await api.get('/v2/subscriptions/current');
    return response.data.data;
  },

  startTrial: async (): Promise<{ trialEndsAt: string; creditLimitCents: number }> => {
    const response = await api.post('/v2/subscriptions/start-trial');
    return response.data.data;
  },

  createCheckoutSession: async (seats: number): Promise<{ checkoutUrl: string }> => {
    const response = await api.post('/v2/subscriptions/checkout', { seats });
    return response.data.data;
  },

  createPortalSession: async (): Promise<{ portalUrl: string }> => {
    const response = await api.post('/v2/subscriptions/portal');
    return response.data.data;
  },

  updateSpendLimits: async (limits: {
    monthlySpendLimitCents?: number;
    perUserSpendLimitCents?: number;
  }): Promise<void> => {
    await api.put('/v2/subscriptions/spend-limits', limits);
  },
};
